import React, {useContext, useRef} from 'react';
import { useLoseFocus } from '../core/Hooks';

import "../assets/scss/Modal.scss";



const ModalContext = React.createContext();

const Modal = ( {active, children, onDismiss} ) => {

  const modalRef = useRef();
  useLoseFocus( modalRef, onDismiss );

  return (
    <ModalContext.Provider value={{ active, onDismiss }}>
      <div className={ "lightbox " + (active && 'active') }>
        <div ref={modalRef} className="modal">
          { children }
        </div>
      </div>
    </ModalContext.Provider>
  );
}



function useModalContext() {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error(
      `Toggle compound components cannot be rendered outside the Toggle component`,
    )
  }

  return context;
}

function DismissButton({children})
{
  const {onDismiss} = useModalContext()
  return (
    <span onClick={ onDismiss }>
      { children }
    </span>
  )
}


Modal.DismissButton = DismissButton;

Modal.defaultProps = {
  onDismiss: () => {}
}


export default Modal;
